import React, { Component } from "react";
import { Link, Switch, Route } from "react-router-dom";
import Header from "./components/common/Header";
import Steps from "./components/intro/Steps";
import CourseList from "./components/learner/CourseList";
import Footer from "./components/common/Footer";
import LiveClass from "./components/learner/LiveClass";
// import CourseDetail from "./components/learner/CourseDetail";
import TopicDetail from "./components/learner/TopicDetail";
import CreateSession from "./components/trainer/CreateSession";
import Join from "./components/learner/Join";
import Profile from "./components/trainer/Profile";
import ScrollToTop from "react-router-scroll-top";
import Home from "./components/home/Home";
import ViewVideo from "./components/video/ViewVideo";
import CreateCourse from "./components/trainer/CreateCourse";
import TopicListLearner from "./components/learner/TopicListLearner";
import Welcome from "./components/admin/Welcome";
import Dashboard from "./components/admin/Dashboard";
import Users from "./components/admin/Users";
import Courses from "./components/admin/Courses";
import Categories from "./components/admin/Categories";
import Groups from "./components/admin/Groups";
import UserTypes from "./components/admin/UserTypes";
import Settings from "./components/admin/Settings";
import Reports from "./components/admin/Reports";
import AddUser from "./components/admin/AddUser";
import AddCourse from "./components/admin/AddCourse";
import AddCategory from "./components/admin/AddCategory";
import AddGroup from "./components/admin/AddGroup";
import AddUserType from "./components/admin/AddUserType";
import Branches from "./components/admin/Branches";
import AddBranch from "./components/admin/AddBranch";
import LearnerCalendar from "./components/learner/LearnerCalendar";
import Batches from "./components/admin/Batches";
import Subscriptions from "./components/admin/Subscriptions";
import AddBatch from "./components/admin/AddBatch";
import AddEvent from "./components/trainer/AddEvent";
import CourseListLearner from "./components/learner/CourseListLearner";
import Registration from "./components/common/Registration";
import Topics from "./components/admin/Topics";
import UpdateCategory from "./components/admin/UpdateCategory";
import UpdateUser from "./components/admin/UpdateUser";
import AddTopic from "./components/admin/AddTopic";
import UpdateUserType from "./components/admin/UpdateUserType";
import UpdateCourse from "./components/admin/UpdateCourse";
import ViewTopic from "./components/admin/ViewTopic";
import QuizContainer from "./components/Create/quiz/QuestionContainer";
import Domains from "./components/admin/Domains";
import AddDomain from "./components/admin/AddDomain";
import EditTopic from "./components/admin/EditTopic";
import CourseContainer from "./components/Create/HTML/CourseContainer";
import { PrivateRoute } from "./components/PrivateRoute";
import CourseReport from "./components/reports/course/CourseReport";
import SpecficCourseReport from "./components/reports/course/SpecficCourseReport";
import UserReport from "./components/reports/user/UserReport";
import SpecificUserReport from "./components/reports/user/SpecificUserReport";
import TestReport from "./components/reports/test/TestReport";
import SpecificTestReport from "./components/reports/test/SpecificTestReport";
import AdminLogin from "./components/common/AdminLogin";
import AssignCourse from "./components/admin/AssignCourse";
import ActivityLogs from "./components/admin/ActivityLogs";
import Conferences from "./components/admin/conferences/Conferences";
import AddConferences from "./components/admin/conferences/AddConferences";
import LMSPageInfo from "./components/about/LMSPageInfo";
import MyCertificates from "./components/learner/MyCertificates";
// import CustomReport from './components/reports/customReport/CustomReport';

export default class App extends Component {
 
  render() {
    return (
      <div>
        <Header></Header>

        <Switch>
          <ScrollToTop>
            <Route exact path={"/"} component={Home} />
            <Route exact path={"/registration"} component={Registration} />
            <Route exact path={"/admin"} component={AdminLogin} />
            {/* <Route exact path={"/course"} component={CourseDetail} /> */}
            <Route exact path={"/trainer"} component={Steps} />
            <Route exact path={"/courses"} component={CourseList} />
            <Route exact path={"/course/topic"} component={TopicDetail} />
            <Route exact path={"/liveClass"} component={LiveClass} />
            <Route exact path={"/createsession"} component={CreateSession} />
            <Route exact path={"/join"} component={Join} />
            {/* <Route exact path={"/profile"} component={Profile} /> */}
            <Route exact path={"/welcome"} component={Welcome} />
            <Route
              exact
              path={"/trainer/create-course"}
              component={CreateCourse}
            />
            <Route
              exact
              path={"/learner/course-list"}
              component={CourseListLearner}
            />
            <Route
              exact
              path={"/learner/course/:courseID"}
              component={TopicListLearner}
            />
            <PrivateRoute
              exact
              path={"/admin/dashboard"}
              component={Dashboard}
            />
            <PrivateRoute
              exact
              path={"/trainer/dashboard"}
              component={Dashboard}
            />

            <PrivateRoute exact path={"/admin/domains"} component={Domains} />
            <PrivateRoute exact path={"/admin/users"} component={Users} />
            <PrivateRoute exact path={"/admin/courses"} component={Courses} />
            <PrivateRoute
              exact
              path={"/admin/course/:course_id"}
              component={UpdateCourse}
            />
            <PrivateRoute
              exact
              path={"/admin/course/assign/:course_id"}
              component={AssignCourse}
            />
            <PrivateRoute
              exact
              path={"/certificates/:course_id"}
              component={MyCertificates}
            />
            <PrivateRoute
              exact
              path={"/activity-logs"}
              component={ActivityLogs}
            />
            <PrivateRoute
              exact
              path={"/admin/categories"}
              component={Categories}
            />
            <PrivateRoute exact path={"/admin/groups"} component={Groups} />
            <PrivateRoute
              exact
              path={"/admin/user-types"}
              component={UserTypes}
            />
            <PrivateRoute exact path={"/admin/batches"} component={Batches} />
            <PrivateRoute
              exact
              path={"/admin/subscriptions"}
              component={Subscriptions}
            />
            <PrivateRoute exact path={"/admin/settings"} component={Settings} />
            <PrivateRoute exact path={"/admin/reports"} component={Reports} />
            <PrivateRoute
              exact
              path={"/admin/reports/course"}
              component={CourseReport}
            />
            <PrivateRoute
              exact
              path={"/admin/reports/user"}
              component={UserReport}
            />
            <PrivateRoute
              exact
              path={"/admin/reports/test"}
              component={TestReport}
            />
            <PrivateRoute
              exact
              path={"/admin/reports/course/:courseID"}
              component={SpecficCourseReport}
            />
            <PrivateRoute
              exact
              path={"/admin/reports/user/:userID"}
              component={SpecificUserReport}
            />
            <PrivateRoute
              exact
              path={"/admin/reports/test/:testID"}
              component={SpecificTestReport}
            />
            <PrivateRoute exact path={"/admin/branches"} component={Branches} />
            <PrivateRoute exact path={"/admin/add-user"} component={AddUser} />
            <PrivateRoute
              exact
              path={"/admin/add-domain"}
              component={AddDomain}
            />
            <PrivateRoute
              exact
              path={"/admin/user/:user_id"}
              component={UpdateUser}
            />
            <PrivateRoute
              exact
              path={"/admin/add-course"}
              component={AddCourse}
            />
            <PrivateRoute
              exact
              path={"/admin/add-category"}
              component={AddCategory}
            />
            <PrivateRoute
              exact
              path={"/admin/category/:category_id"}
              component={UpdateCategory}
            />
            <PrivateRoute
              exact
              path={"/admin/add-group"}
              component={AddGroup}
            />
            <PrivateRoute
              exact
              path={"/admin/add-user-type"}
              component={AddUserType}
            />
            <PrivateRoute
              exact
              path={"/admin/add-branch"}
              component={AddBranch}
            />
            <PrivateRoute
              exact
              path={"/admin/add-batch"}
              component={AddBatch}
            />
            <PrivateRoute
              exact
              path={"/learner/calendar"}
              component={LearnerCalendar}
            />
            <PrivateRoute
              exact
              path={"/calendar/add-event"}
              component={AddEvent}
            />
            <PrivateRoute exact path={"/view_video"} component={ViewVideo} />

            <PrivateRoute
              exact
              path={"/admin/course/topics/:course_id"}
              component={Topics}
            />
            <PrivateRoute exact path={"/user-detail/:id"} component={Profile} />
            <PrivateRoute
              exact
              path={"/admin/add-topic/:course_id"}
              component={AddTopic}
            />
            <PrivateRoute
              exact
              path={"/admin/user-type/:user_type_id"}
              component={UpdateUserType}
            />
            <PrivateRoute
              exact
              path={"/create-course/:course_id"}
              component={CourseContainer}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path={"/admin/view-topic/:course_id&:topic_id"}
              component={ViewTopic}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path={"/trainer/view-topic/:course_id&:topic_id"}
              component={ViewTopic}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path={"/learner/view-topic/:course_id&:topic_id"}
              component={ViewTopic}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path={"/admin/edit-topic/:course_id&:topic_id"}
              component={EditTopic}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path={"/create-quiz/:course_id"}
              component={QuizContainer}
            ></PrivateRoute>
            <PrivateRoute
              exact
              path={"/lmsPageInfo"}
              component={LMSPageInfo}
            ></PrivateRoute>
          </ScrollToTop>
        </Switch>

        <Footer></Footer>
      </div>
    );
  }
}
